import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const UpdateMainCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    status: '1'
  });

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const res = await getRequest(`main-categories/${id}`);
        const item = res?.data || {};
        setFormData({
          name: item.name || '',
          status: String(item.status ?? '1')
        });
      } catch (err) {
        console.error('Failed to fetch main category:', err);
      }
    };
    fetchOne();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await patchRequest(`main-categories/${id}`, formData);
      toast.success('Main category updated successfully!');
      navigate('/main-categories');
    } catch (error) {
      console.error('Failed to update main category:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Main Category</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateMainCategory;
